<template>
  <div class="book-main">
    <div class="book-head">
      <div class="book-info">
        <h1>{{info.article_title}}</h1>
        <div class="sub-title">{{info.article_summary || '暂无简介。'}}</div>
        <div class="author-info" v-if="info.authorData.uid">
          <div class="avatar">
            <Avatar :src="info.authorData.avatar" :size="isMobile ? 26 : 42" />
          </div>
          <div class="author-profile">
            <div class="author-name">
              <h6>
                <span>{{info.authorData.authorLabel}}：</span>
                <AuthorName :uid="info.authorData.uid" :name="info.authorData.nickname" />
              </h6>
              <!-- <FollowButton
                class="follow-btn"
                type="user"
                size="small"
                :id="info.authorData.uid"
                :follow="info.authorData.is_sub"
                unlabel="已关注"
              /> -->
            </div>
            <p class="author-summary" v-if="!isMobile && info.authorData.summary">{{info.authorData.summary}}</p>
          </div>
          <gkButton class="download-btn" color="download" @click="$emit('viewDownloadBtn')">下载此书</gkButton>
        </div>
      </div>

      <div class="book-cover" :class="{'wap-book-image': isMobile}">
        <div class="image-shadow" v-if="isMobile"></div>
        <img :src="info.article_cover | image({resize:{h: 496}})" :alt="info.article_title" />
      </div>
    </div>

    <RichContent class="article-content" :title="info.article_title" :content="info.content" />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import utils from '../../utils/'

import gkButton from 'gkui/button'
import FollowButton from '../../components/button/FollowButton'
import Avatar from '../../components/Avatar'
import AuthorName from '../../components/title/AuthorName'
import RichContent from './RichContent'

export default {
  name: 'book-content',
  components: {
    gkButton,
    FollowButton,
    Avatar,
    AuthorName,
    RichContent
  },
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser'])
  },
  created () {
    utils.shareWeixin({
      title: `《${this.info.article_title}》 - InfoQ 迷你书`,
      desc: this.info.article_subtitle || this.info.article_summary,
      imgUrl: this.info.share_pic
    })
  },
  mounted () {
    this.initOpenInTab()
  },
  methods: {
    /**
     * 给所有 a 标签添加 target属性 外链 新标签页打开
     */
    initOpenInTab () {
      let tags = document.querySelector('.book-main').querySelectorAll('a')
      tags.forEach(item => {
        item.setAttribute('target', '_blank')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.book-main {
  width: 100%;
}
.book-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 45px;
}

.book-info {
  flex: 1;
  margin-right: $gridSpace;

  & h1 {
    line-height: 36px;
    @include font(24, 400);
  }

  & .sub-title {
    padding: 12px 0 41px;
    line-height: 32px;
    @include font(18, 400);
    color: $lightBlack;
  }
}

.book-cover {
  flex: 146px 0 0;
  height: 211px;
  box-shadow: 0 8px 28px 0 rgba(152, 157, 161, 0.55);

  & img {
    display: block;
    width: 100%; height: 100%;
    border-radius: 3px;
  }
}

.author-info {
  display: flex;
  align-items: center;

  & .avatar {
    flex: 42px 0 0;
    height: 42px;
  }

  & .author-profile {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 1px 0 0 11px;
  }

  & .author-name {
    display: flex;
    align-items: center;
    height: 20px;

    & h6 {
      margin-right: 20px;
      @include row(1);
      @include lineFont(14, 400);
      color: $black;

      & span:first-child {
        margin-right: -8px;
        font-weight: 400;
        color: $gray;
      }
    }
  }

  & .download-btn {
    width: 92px; height: 36px; 
    border-radius: 36px;
  }

  & .follow-btn {
    width: 50px; height: 18px;
  }

  & .author-summary {
    padding-top: 9px;
    @include lineFont(12, 400);
    color: $lightBlack;
  }
}

@media screen and (max-width: 768px) {
  .book-head {
    flex-direction: column;
    padding-bottom: 30px;
  }

  .book-cover {
    order: -1;
    flex: 1;
    height: 248px;
    box-shadow: none;
  }

  .wap-book-image {
    box-sizing: border-box;
    position: relative;
    padding-top: 48px;

    &:before,
    &:after {
      content: ' ';
      display: block;
      position: absolute; left: 50%;
      width: 104px; height: 51px;
      background: url('../../assets/img/book-bg.png') no-repeat;
      background-size: contain;
    }

    &:before {
      top: 78px;
      margin-left: -85px;
    }
    &:after {
      top: 130px;
      margin-left: -12px;
    }

    & img {
      position: relative; z-index: 1;
      display: block;
      width: 115px; height: auto;
      margin: 0 auto;
      border-radius: 3px;
    }

    & .image-shadow {
      display: block;
      position: absolute; left: 50%; top: 78px;
      width: 92px; height: 130px;
      margin-left: -46px;
      box-shadow: 0 4px 7px 0 rgba(199, 209, 215, 0.75);
    }
  }

  .book-info {
    margin: 0;

    & h1 {
      font-weight: 500;
    }

    & .sub-title {
      padding: 8px 0 15px;
      line-height: 27px;
    }
  }

  .author-info {
    align-items: center;

    & .avatar {
      flex: 26px 0 0;
      height: 26px;
    }

    & .author-profile {
      padding: 0 0 0 10px;
    }

    & .author-name h6 {
      margin-right: 10px;
      @include lineFont(12, 400);
    }
    & .download-btn {
      width: 92px; height: 26px; 
      border-radius: 26px;
    }

  }
}
</style>


 